import { Alert, Box, Typography } from "@mui/material";
import { useAccountLimitsContext } from "../../../../context/account-limit-context";
import { SlackAliasTable } from "./alias-table";

import type { FC } from "react";

export const SlackAlias: FC = () => {
  const { slack_aliases: limit } = useAccountLimitsContext();

  return (
    <>
      <Typography variant="h6">Add Slack Alias</Typography>
      <Typography variant="subtitle2" color="text.secondary">
        Your Slack bot has a base logo and title which is set up by an Admin, typically your company
        Logo and Name. However, you can create an Alias for your Bot here so that some messages look
        as though they are coming from a different brand or person. For e.g you may want to send
        Holiday Communications from a Holiday Bot. Use the table below to create new Aliases.
      </Typography>
      {limit === 0 && (
        <Alert severity="info" sx={{ mb: 2 }}>
          Slack aliases are not enabled on your account, contact your Customer Success
          representative for more information
        </Alert>
      )}
      <Box sx={{ mt: 3 }}>
        <SlackAliasTable aliasLimit={limit ?? 0} />
      </Box>
    </>
  );
};
